module.exports = __webpack_public_path__ + "static/img/21.af03cb3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pcho/11/21.png
// module id = NErW
// module chunks = 0